export const NormalizedData = (obj: any, key: string) => {
  if (!obj || !key) return undefined;
  const normalizedKey = Object.keys(obj).find(
    (k) => k.toLowerCase() === key.toLowerCase()
  );
  return normalizedKey ? obj[normalizedKey] : undefined;
};

export const getSortedGridHeaders = (gridHeaders: any[] = []) =>
  [...gridHeaders].sort((a, b) => (a?.sortOrder || 0) - (b?.sortOrder || 0));

export const getActiveTab = (gridHeaders: any[] = [], tabIndex = 0) =>
  getSortedGridHeaders(gridHeaders)[tabIndex];

export const getActiveTabSortOrder = (gridHeaders: any[] = [], tabIndex = 0) =>
  getActiveTab(gridHeaders, tabIndex)?.sortOrder ?? 0;

export const getVisibleTabHeaders = (tabHeaders: any[] = []) =>
  tabHeaders.filter(
    (col) => col?.isShowOnUi && !col?.isExpandData && col?.isShow
  );

export const getCompleteLabelBySortOrder = (sortOrder: number) => {
  if (sortOrder === 3) return "Complete 48h";
  if (sortOrder === 4) return "Complete 72h";
  return "Complete 24h";
};
